// extracted by mini-css-extract-plugin
module.exports = {"grid":"DepartmentsList_grid__1LfpI"};